module.exports = __webpack_public_path__ + "fonts/newkidsmd.e46c8e0.otf";